import React from 'react'

const SeguimientoPedido = () => {
    return (
        <div className='container-seguimiento-pedido '>
            <div className='row align-items-center justify-content-center'>
                <form className="text-center p-5" action="#!">
                    <p className="h4 mb-2 font-weight-bold">Estado de Pedido</p>
                    <p>Proporciona el No. del pedido de la compra para rastrear tu pedido:</p>

                    <input
                        type="text"
                        id="defaultSubscriptionFormPassword"
                        className="form-control mb-4"
                        placeholder="No. de Orden"
                    />

                    <button className="btn btn-purple btn-block btn-rounded  font-weight-bold" type="submit">
                        RASTREAR PEDIDO
                    </button>
                </form>
            </div>
        </div>
    )
}

export default SeguimientoPedido